import React from 'react'
import ControlledModal from '../../modals/ControlledModal'
import { useModalData } from '../../modals/ModalsContext'
import { FilterHandler } from '@btime/react-contexts'
import { HorizontalLine } from '../../shapes/Line'
import { COLORS } from '@btime/constants'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import GroupedPointsTable from './table/GroupedPointsTable'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import ModalHeader from './ModalHeader'

const MapGroupedDetail = props => {
  const items = useModalData()
  if (!items || !items.map) return false

  return (
    <ControlledModal maxHeight="45rem" minHeight={'10rem'} width="30rem" {...props}>
      <FilterHandler tempStorageNamespace="groupedPoints" initialState={{}}>
        <ModalHeader />
        <Separator weight={2} />
        <HorizontalLine thin lineColor={COLORS.light2} />
        <Scroll maxHeight="35rem" minHeight={'5rem'}>
          <Separator weight={-5} />
          <GroupedPointsTable />
        </Scroll>
        <Separator weight={5} />
      </FilterHandler>
    </ControlledModal>
  )
}

export default MapGroupedDetail
